(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.transitionDuration = 300;
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBackdrop = document.getElementById('header-backdrop');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.mouseOutTimeout = null;

      // this.setHeaderHeight();
      window.addEventListener('load', this.setHeaderHeight.bind(this));

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.onResizeHandler = this.onResize.bind(this);
      window.addEventListener('resize', this.onResizeHandler, false);

      this.createObserver();

      // Custom behaviours
      this.moreButton = this.querySelector('.header__more');
      this.facetWrapper = document.querySelector('.facets-container');
      this.hasFacets = this.facetWrapper ? true : false;
      this.headerDropdown = this.querySelector('nav.header__inline-menu');

      this.hamburgerPaths = this.querySelector('#header-more-hamburger').querySelectorAll('path');

      if (this.hasFacets) this.classList.add('has-facets');

      this.onMoreButtonClick = (e) => {
        e.preventDefault();
        if (this.dropdownOpened) {
          this.closeHeaderDropdown();
          return;
        }
        this.openHeaderDropdown()
      };
      
      this.moreButton.addEventListener('click', this.onMoreButtonClick.bind(this));
      this.headerBackdrop.addEventListener('click', this.closeHeaderDropdown.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.clientHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop);
      

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.hasFacets && scrollTop > this.currentScrollTop) { 
        document.documentElement.classList.add('scroll-down');
      } else if (scrollTop < document.documentElement.scrollHeight - vh) {
        document.documentElement.classList.remove('scroll-down');
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;

      if (this.dropdownOpened) {
        this.closeHeaderDropdown();
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }

    // Custom behaviours

    onResize() {
      debounce(this.setHeaderHeight.bind(this), 100)();
      // this.setHeaderHeight();
      if (this.dropdownOpened) {
        this.style.height = `${this.scrollHeight}px`;
      }
    }

    // Calls a function every frame until the condition is false
    callbackWhile(condition, callback) {
      if (condition()) {
        callback();
        requestAnimationFrame(() => this.callbackWhile(condition, callback));
      }
    }

    openHeaderDropdown() {
      window.removeEventListener('scroll', this.onScrollHandler);
      clearTimeout(this.dropdownOpenedTimeout);
      this.dropdownOpened = true;
      this.style.willChange = 'height';
      this.style.height = `${this.scrollHeight}px`;
      document.documentElement.classList.add('collapse-facets');
      document.documentElement.classList.add("collapse-facets-dropdown");
      this.dropdownOpenedTimeout = setTimeout(() => {
        this.style.height = 'fit-content';
        this.style.removeProperty('will-change');
        window.addEventListener('scroll', this.onScrollHandler);
      }, this.transitionDuration);
      const transitionStart = performance.now();
      this.callbackWhile(() => {return performance.now() < transitionStart + this.transitionDuration && this.dropdownOpened}, () => {
        this.setHeaderHeight();
        const time = (performance.now() - transitionStart) / this.transitionDuration;
        this.animateHamburger(time);
      });
      this.updateFocusableElements();
      this.headerBackdrop.style.display = 'block';
    }

    closeHeaderDropdown() {
      clearTimeout(this.dropdownOpenedTimeout);
      this.dropdownOpened = false;
      this.style.height = `${this.scrollHeight}px`;
      this.dropdownOpenedTimeout = setTimeout(() => {
        this.style.willChange = 'height';
        this.style.removeProperty('height');
        document.documentElement.classList.remove('collapse-facets');
        this.dropdownOpenedTimeout = setTimeout(() => {
          this.style.removeProperty('will-change');
        }, this.transitionDuration);
        const transitionStart = performance.now();
        this.callbackWhile(() => {return performance.now() < transitionStart + this.transitionDuration && !this.dropdownOpened}, () => {
          this.setHeaderHeight();
          const time = (performance.now() - transitionStart) / this.transitionDuration;
          this.animateHamburger(time);
          this.style.removeProperty('will-change');
        });
      }, 0);
      this.updateFocusableElements();
      this.headerBackdrop.style.removeProperty('display');
    }

    updateFocusableElements() {
      const focusableElements = this.querySelectorAll("a[href], button, label, input, select, textarea, [tabindex], summary");
      document.activeElement.closest('sticky-header') && document.activeElement.blur();
      if (this.dropdownOpened) focusableElements.forEach(element => element.removeAttribute("tabindex"));
      else focusableElements.forEach(element => element.setAttribute("tabindex", "-1"));
    }

    animateHamburger(time) {
      const isOpen = this.dropdownOpened;

      function interpolatePath(path, targetD, time) {
        const currentInstruction = path.split(" ");
        const targetInstruction = targetD.split(" ");
        if (currentInstruction.length !== targetInstruction.length) return targetD;
        return currentInstruction.map((instruction, index) => {
          if (!instruction.match(/[0-9\-\.e]+/g)) return instruction;
          return lerp(parseFloat(instruction), parseFloat(targetInstruction[index]), time);
        }).join(" ");
      }

      this.hamburgerPaths.forEach((path, index) => {
        path.setAttribute('d', interpolatePath(
          path.getAttribute('d'), 
          isOpen ? path.getAttribute('d-open') : path.getAttribute('d-close'), 
          time
        ));
      });
    }
  }

  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();
})();
